import styled from '@emotion/styled'
import { Icon } from '../Icon'

const MenuOptionArrow = styled(Icon)`
    margin: 0 -10px 0 5px;
`

export { MenuOptionArrow }
